var map = {
	"./1.png": 42309,
	"./10.png": 81761,
	"./2.png": 14478,
	"./3.png": 13975,
	"./4.png": 91832,
	"./5.png": 12961,
	"./6.png": 71882,
	"./7.png": 87443,
	"./8.png": 61524,
	"./9.png": 82653,
	"./bg.png": 96739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80181;